import { Injectable } from '@angular/core';
import { BehaviorSubject, Observable } from 'rxjs';
import { Ambience } from '../../models/ambience.model';
import { HttpClient } from '@angular/common/http';
import { environment } from 'src/environments/environment';

@Injectable({
  providedIn: 'root',
})
export class EnvironmentService {
  private readonly API = `${environment.api_url}`;
  private environmentSource = new BehaviorSubject<Ambience>(this.getAmbiente());
  environment$ = this.environmentSource.asObservable();

  constructor(private http: HttpClient) {}

  setEnvironment(ambiente: Ambience) {
    this.environmentSource.next(ambiente);
    localStorage.setItem('ambiente', JSON.stringify(ambiente));
    window.location.reload();
  }

  getAmbiente(): Ambience | null {
    const ambiente = localStorage.getItem('ambiente');
    return ambiente && ambiente !== '{}' ? JSON.parse(ambiente) : null;
  }

  getAmbientesComFundos(): Observable<any[]> {
    return this.http.get<any[]>(`${this.API}/config/connectionStrings`);
  }
}
